import { Field } from 'payload'
import { mergeObjects } from '@utils/objects'
import { CellComponentFormat } from '@components/(payload)/fields/cell'

/**
 * Add a cell component to format field value
 *
 * @param config
 * @returns
 */
export function addCellComponent<T extends Field = Field>(field: Partial<T>, format: CellComponentFormat): T[] {
  const configDefault = {
    admin: {
      components: {
        Cell: {
          path: '@components/(payload)/fields/cell',
          clientProps: {
            format
          }
        }
      },
    }
  };

  const merged = mergeObjects(configDefault, field) as T;
  return [ merged ];
}